export const products = [
    {
        id: 43,

        title: 'CHILI MAGIC (крем + косметичка + ролик)',
        desc_short:
            'Нежная прохладная гелевая текстура виноградного обертывания обеспечит интенсивный уход за кожей тела и продлит ее молодость. Полифенолы, являются одними из самых мощных антиоксидантов растительного',
        desc: 'Средство для антицеллюлитного обертывания или массажа, предотвращает появления растяжек и целлюлита, в комплексе с массажным роликом является активным средством по борьбе с несовершенствами кожи и поддержанием ее здорового состояния. Хорошо разогревает кожу, улучшает кровообращение, стимулирует выравнивание кожи. Для всех типов кожи, для зонального применения. Разогревающий эффект. Смягчение, стимуляция кожи. В комплект входит косметичка. Не рекомендуется использовать во время беременности и лактации',
        count: 1,
        weight: 350,
        weightType: 'Г',
        cost: 2490,
        categories: 'Бестселлеры, Для рук и ног, Для тела',
        imageUrl: 'https://1790009369.rsc.cdn77.org/images/tovar-1.png',
        zagolovok_sostava: 'Состав крема',
        sostav: 'Aqua,Triticumvulgare(Wheat)Germoil, ButyrospermumParkii(Shea)oil,Glycerin(Vegetable), Cetearyl Alcohol, Polysorbate 60, Theobroma Cacao (Cocoa) Seed Butter, Vitis Vinifera (Grape) Seed Oil, Coffea Arabica (Coffee) Seed oil, Colloidal Gold, Capsicum Annuum Extract, Glyceryl Stearate, Palmitic Acid, Cellulose Gum, Laminaria Extract, Isopropyl Palmitate, Carbomer, Dehydroacetic Acid, Benzyl Alcohol, Disodium Edta, Sodium Hydroxide, Fragrance.',
        blok_rekomendaciya_zagolovok: 'РЕКОМЕНДУЕТ ИМЕННО ЭТОТ ПРОДУКТ?',

        blok_rekomendaciya_podpis_k_zagolovku: 'ПОЧЕМУ ЛИЗА МИЛЛЕР',

        blok_rekomendaciya_kontent:
            'Нежная прохладная гелевая текстура виноградного обёртывания обеспечит интенсивный уход за кожей тела и продлит её молодость\n\n&nbsp;\n\nНасыщенный состав позволит быстро уменьшить объёмы в «проблемных зонах», подтянуть и тонизировать кожу. Регулярное использование обёртывания сделает кожу гладкой и упругой',

        blok_rekomendaciya_ikonka_v_ramke: 143,

        blok_rekomendaciya_zagolovok_v_ramke: 'Полифенолы, содержащиеся в виноградной косточке',

        blok_rekomendaciya_opisanie_v_ramke: 'являются одними из самых мощных антиоксидантов растительного происхождения',

        blok_effekt_zagolovok: 'Эффект',

        blok_effekt_opisanie_sverhu: 'Экстракт винограда позволяет эффективно увлажнить кожу и способствует выведению шлаков',

        blok_effekt_opisanie_snizu:
            'Защищает от вредного воздействия свободных радикалов. Стимулирует выработку коллагена и регенерацию клеток эпидермиса, а также оказывает anti-age эффект',

        blok_effekt_dobavit_effekt: 3,

        blok_ingredienty_zagolovok: 'ДЕЙСТВУЮЩИЕ ИНГРЕДИЕНТЫ',

        blok_ingredienty_ingredient_1: 'ЭКСТРАКТ ЧИЛИ',

        blok_ingredienty_ingredient_2: 'МАСЛО ВИНОГРАДНОЙ КОСТОЧКИ',

        blok_ingredienty_ingredient_3: 'МАСЛО ШИ',

        blok_ingredienty_ingredient_4: 'МАСЛО КАКАО',

        blok_ingredienty_ingredient_5: 'МАСЛО КОФЕ',

        blok_ingredienty_ingredient_6: 'ЭКСТРАКТ ЛАМИНАРИИ',

        blok_ingredienty_ingredient_7: 'МАСЛО ПШЕНИЦЫ',

        blok_primenenie_kontent:
            'Нанести небольшое количество крема на проблемные участки бедер, ягодиц, живота, растереть крем по массажным линиям и сделать массаж с помощью ролика. Важно! Крем нельзя смывать ранее, чем через 30 минут после нанесения, так как может появиться сильное жжение',

        blok_do_i_posle_zagolovok: 'А так же до/после',

        blok_effekt_dobavit_blok_effekta_0_img: 'https://1790009369.rsc.cdn77.org/images/61a1f36de70082183a88e65e_GroD0B0up2089.png',
        blok_effekt_dobavit_blok_effekta_1_img: 'https://1790009369.rsc.cdn77.org/images/Group-d9.png',
        blok_effekt_dobavit_blok_effekta_2_img: null,

        blok_effekt_dobavit_effekt_0_effekt: 'УМЕНЬШАЕТ ОБЪЕМЫ В ПРОБЛЕМНЫХ ЗОНАХ',

        blok_effekt_dobavit_effekt_1_effekt: 'НАСЫЩАЕТ КОЖУ ВИТАМИНАМИ И МИКРОЭЛЕМЕНТАМИ',

        blok_effekt_dobavit_effekt_2_effekt: 'ПРОДЛЕВАЕТ МОЛОДОСТЬ',

        blok_effekt_dobavit_blok_effekta_0_zagolovok:
            'Экстракт винограда позволяет эффективно увлажнить кожу и способствует выведению шлаков',

        blok_effekt_dobavit_blok_effekta_0_opisanie:
            'Защищает от вредного воздействия свободных радикалов. Стимулирует выработку коллагена и регенерацию клеток эпидермиса, а также оказывает anti-age эффект',

        blok_effekt_dobavit_blok_effekta_1_zagolovok: 'Ролик добавляет эффект упругости и подтянутости',

        blok_effekt_dobavit_blok_effekta_1_opisanie:
            'Массажный ролик выполнен из специальных материалов, которые позволяют достичь эффект упругости и подтянутости всего за 2 месяца',

        postoyannye_dannye_zagolovok_sostava: 'Состав крема',
        postoyannye_dannye_podpis_sostav: 'Посмотрите состав крема, нажав на кнопку',
        postoyannye_dannye_podpis_vesa: 'Вес упаковки',
        postoyannye_dannye_zagolovok_kompleks: 'Целый комплекс',
        postoyannye_dannye_podpis_kompleks: 'В набор входит косметичка, ролик и крем для ухода за собой',

        naznachenie_tovara: 'АНТИЦЕЛЛЮЛИТНЫЙ КРЕМ-ОБЕРТЫВАНИЕ',
        podpis_v_hlebnyh_kroshkah: 'Антицеллюлитный крем-обёртывание Chili Magic',
        blok_primenenie_video_video: 'https://www.youtube.com/watch?v=bHCItCySFK0',

        blok_primenenie_video_poster: 282,

        blok_otzyvy_zagolovok: 'Отзывы наших клиентов'
    },
    {
        id: 259,

        title: 'Ginger Power - масло + банка массажная',
        'рекомендуемый?': 1,
        'Видимость в каталоге': 'visible',
        desc_short: 'Масло для тела укрепляет кожу, повышает эластичность и способствует уменьшению целлюлита.',
        desc: 'Масло для тела укрепляет кожу, повышает эластичность и способствует уменьшению целлюлита. Предназначено для массажа с целью коррекции фигуры. Консистенция способствует легкому скольжению, позволяет сделать глубокий массаж тканей, разглаживая текстуру и визуально подтягивая силуэт. Имеет ценный состав на основе чистых растительных масел мощного действия. Олива, миндаль и жожоба укрепляют, увлажняют и подтягивают кожу. Экстракт имбиря способствует выведению токсинов, стимулируя нормальное обновление кожи. Он от природы богат антиоксидантами, которые помогают снизить окислительный стресс.',

        count: 1,

        weight: 200,
        weightType: 'Г',
        cost: 1190,
        categories: 'Бестселлеры, Для рук и ног, Для тела',
        imageUrl: 'https://1790009369.rsc.cdn77.org/image/oil1.png',

        zagolovok_sostava: 'Состав масла',
        sostav: 'Helianthus Annuus Seed il, Olea Europaea (Olive) Oil, Simmondsia Chinensis (Jojoba) Seed Oil, Vitis Vinifera (Grape) Seed Oil, Prunus Amygdalus Dulcis (Sweet Almond) Oil,Тосоpherol, Zingiber Ocinale (Ginger) Extract, Fragrance.**',
        blok_rekomendaciya_zagolovok: 'РЕКОМЕНДУЕТ ИМЕННО ЭТОТ ПРОДУКТ?',

        blok_rekomendaciya_podpis_k_zagolovku: 'ПОЧЕМУ ЛИЗА МИЛЛЕР',

        blok_rekomendaciya_kontent:
            'Нежная прохладная гелевая текстура виноградного обёртывания обеспечит интенсивный уход за кожей тела и продлит её молодость. Насыщенный состав позволит быстро уменьшить объёмы в «проблемных зонах», подтянуть и тонизировать кожу. Регулярное использование обёртывания сделает кожу гладкой и упругой',

        blok_rekomendaciya_ikonka_v_ramke: null,

        blok_rekomendaciya_zagolovok_v_ramke: null,

        blok_rekomendaciya_opisanie_v_ramke: null,

        blok_effekt_zagolovok: 'Эффект',

        blok_ingredienty_zagolovok: 'ДЕЙСТВУЮЩИЕ ИНГРЕДИЕНТЫ',

        blok_ingredienty_ingredient_1: 'ОЛИВА',

        blok_ingredienty_ingredient_2: 'МИНДАЛЬ',

        blok_ingredienty_ingredient_3: null,

        blok_ingredienty_ingredient_4: 'ЭКСТРАКТ ﻿ИМБИРЯ',

        blok_ingredienty_ingredient_5: 'ЖОЖОБА',

        blok_ingredienty_ingredient_6: null,

        blok_ingredienty_ingredient_7: null,

        blok_primenenie_kontent:
            'Нанесите масло зонально на бедра и ягодицы. Сделайте массаж вакуумными банками в течение 10-15 минут. Массируйте восходящими движениями, по направлению тока лимфы. Смойте теплой водой с гелем для душа или не смывайте и дайте ему полностью впитаться.',

        blok_do_i_posle_zagolovok: null,

        blok_effekt_dobavit_blok_effekta_0_img: 'https://1790009369.rsc.cdn77.org/images/zhozhoba.jpeg',
        blok_effekt_dobavit_blok_effekta_1_img: 'https://1790009369.rsc.cdn77.org/images/imbir.png',
        blok_effekt_dobavit_blok_effekta_2_img: 'https://1790009369.rsc.cdn77.org/images/zhir-kletki-.png',

        blok_effekt_dobavit_effekt_0_effekt: 'Укрепляют и подтягивают кожу',

        blok_effekt_dobavit_effekt_1_effekt: 'Разглаживает растяжки и борется с целлюлитом',

        blok_effekt_dobavit_effekt_2_effekt: 'Убирает жировые клетки',

        blok_effekt_dobavit_blok_effekta_0_zagolovok: 'Подтянутая кожа',

        blok_effekt_dobavit_blok_effekta_0_opisanie:
            'Наше масло идеально подходит для массажа и сделано на основе ценных масел оливы, миндаля и жожоба. Эти масла укрепляют кожу и подтягивают ее.',

        blok_effekt_dobavit_blok_effekta_1_zagolovok: 'Кожа без отеков',

        blok_effekt_dobavit_blok_effekta_1_opisanie:
            'Экстракт имбиря в составе выводит токсины, улучшает лимфодренаж в тканях и стимулирует обновление кожи.',

        postoyannye_dannye_zagolovok_sostava: 'Состав крема',
        postoyannye_dannye_podpis_sostav: 'Посмотрите состав крема, нажав на кнопку',
        postoyannye_dannye_podpis_vesa: 'Вес упаковки',

        naznachenie_tovara: 'Антицеллюлитное массажное масло',
        podpis_v_hlebnyh_kroshkah: 'Ginger Power',

        blok_otzyvy_zagolovok: 'Отзывы наших клиентов',

        blok_effekt_dobavit_blok_effekta_2_zagolovok: 'Отсутствие целлюлита',

        blok_effekt_dobavit_blok_effekta_2_opisanie: 'Под воздействием баночного массажа происходит механический разрыв жировых клеток.',

        postoyannye_dannye_podpis_obema: 'Объем упаковки'
    },
    {
        id: 278,

        title: 'Coconut Care - скраб',
        desc_short: 'Нежный ухаживающий скраб с микрочастицами кокоса, сахара и рисовой пудрой',
        desc: '97,9% компонентов натурального происхождения. Отшелушивающее, стимулирующее и увлажняющее средство три в одном, которое делает кожу шелковистой и гладкой. Скраб для тела состоит из мельчайших абразивных частиц кокоса, сахарозы и рисовой пудры, с добавлением легчайшей смеси масла сладкого миндаля и рисовых отрубей, и лимфодренажным комплексом экстрактов центеллы азиатской и женьшеня. Скраб предназначен для профилактики “апельсиновой корки” и растяжек. Средство достаточно мягкое и подходит для частого использования. Кристаллы сахарозы - это натуральные эксфолианты и увлажнители, предотвращающие потерю влаги, бережно удаляют омертвевшие клетки кожи, придавая ей более гладкую и ровную текстуру. Мягкие абразивные частицы кокосовой мякоти и рисовая пудра деликатно скрабируют кожу, улучшая ее микрорельеф и стимулируя ускорение обновления. Они обладают детоксикационным эффектом, увеличивая выведение токсинов и дренаж, тем самым помогая улучшить кровообращение. В результате кожа становится идеально гладкой и ровной.',
        count: 1,
        weight: 250,
        weightType: 'Г',
        cost: 1090,
        categories: 'Бестселлеры, Для рук и ног, Для тела',
        imageUrl: 'https://1790009369.rsc.cdn77.org/images/2-1.png',
        zagolovok_sostava: 'Состав скраба',
        sostav: 'Aqua, Sucrose, Oryza Sativa (Rice) Powder, Prunus Amygdalus Dulcis (Sweet Almond) Oil,\nOryza Sativa (Rice) Germ Oil, Glycerin, Glyceryl Monostearate, Cetearyl Alcohol, Cocos Nucifera\n(Coconut) Powder, Centella Asiatica (Gotu Kola) Extract, Dehydroacetic Acid, Benzyl Alcohol, Cetearyl\nAlcohol, Polysorbate 60, Parfum, Panax Ginseng Root Extract, Xanthan Gum, Tetrasodium EDTA',
        blok_rekomendaciya_zagolovok: 'РЕКОМЕНДУЕТ ИМЕННО ЭТОТ ПРОДУКТ?',

        blok_rekomendaciya_podpis_k_zagolovku: 'ПОЧЕМУ ЛИЗА МИЛЛЕР',

        blok_rekomendaciya_kontent:
            'Нежная прохладная гелевая текстура виноградного обёртывания обеспечит интенсивный уход за кожей тела и продлит её молодость. Насыщенный состав позволит быстро уменьшить объёмы в «проблемных зонах», подтянуть и тонизировать кожу. Регулярное использование обёртывания сделает кожу гладкой и упругой',

        blok_rekomendaciya_ikonka_v_ramke: null,

        blok_rekomendaciya_zagolovok_v_ramke: null,

        blok_rekomendaciya_opisanie_v_ramke: null,

        blok_effekt_zagolovok: 'Эффект',

        blok_ingredienty_zagolovok: 'ДЕЙСТВУЮЩИЕ ИНГРЕДИЕНТЫ',

        blok_ingredienty_ingredient_1: 'КОКОС',

        blok_ingredienty_ingredient_2: 'САХАРОЗА',

        blok_ingredienty_ingredient_3: 'РИСОВАЯ ПУДРА',

        blok_ingredienty_ingredient_4: 'МАСЛО МИНДАЛЯ',

        blok_ingredienty_ingredient_5: 'РИСОВЫЕ ОТРУБИ',

        blok_ingredienty_ingredient_6: 'ЦЕНТЕЛЛА',

        blok_ingredienty_ingredient_7: 'ЖЕНЬШЕНЬ',

        blok_primenenie_kontent:
            'Нанести небольшое количество скраба на влажную кожу. В течение нескольких минут массировать легкими круговыми восходящими движениями, по направлению тока лимфы для улучшения обменных процессов в коже. После процедуры смыть средство тёплой водой.',

        blok_do_i_posle_zagolovok: null,

        blok_effekt_dobavit_effekt_0_effekt: 'Увлажняет и разглаживает кожу, очищает поры',

        blok_effekt_dobavit_blok_effekta_0_img: 'https://1790009369.rsc.cdn77.org/images/risovoe-maslo.jpeg',
        blok_effekt_dobavit_blok_effekta_1_img: 'https://1790009369.rsc.cdn77.org/images/centella-aziatskaya.jpeg',
        blok_effekt_dobavit_blok_effekta_2_img: 'https://1790009369.rsc.cdn77.org/images/kokosovaya-myakot.jpeg',

        blok_effekt_dobavit_effekt_1_effekt: 'Способствует активному процессу расщепления жира',

        blok_effekt_dobavit_effekt_2_effekt: 'Убирает "апельсиновую" корку',

        blok_effekt_dobavit_blok_effekta_0_zagolovok: 'Глубокое увлажнение',

        blok_effekt_dobavit_blok_effekta_0_opisanie:
            'Рисовое масло - это прекрасный природный нутриент для кожи, за счет богатого витамином Е состава во время скрабирования вы глубоко увлажните кожу',

        blok_effekt_dobavit_blok_effekta_1_zagolovok: 'Кожа без отеков',

        blok_effekt_dobavit_blok_effekta_1_opisanie:
            'Скраб наполнен масляными экстрактами женьшеня и центеллы, которые работают в синергии, стимулируя ключевые липолитические процессы и предотвращая образование новых жировых клеток',

        postoyannye_dannye_zagolovok_sostava: 'Состав крема',
        postoyannye_dannye_podpis_sostav: 'Посмотрите состав крема, нажав на кнопку',
        postoyannye_dannye_podpis_vesa: 'Вес упаковки',

        naznachenie_tovara: 'Лимфодренажный скраб',
        podpis_v_hlebnyh_kroshkah: 'Coconut Care',

        blok_otzyvy_zagolovok: 'Отзывы наших клиентов',

        blok_effekt_dobavit_blok_effekta_2_zagolovok: 'Приятные ощущения',

        blok_effekt_dobavit_blok_effekta_2_opisanie:
            'Мягкие абразивные частицы кокосовой мякоти и рисовая пудра деликатно скрабируют кожу, улучшая ее микрорельеф и стимулируя ускорение обновления.',

        postoyannye_dannye_podpis_obema: 'Объем упаковки'
    },
    {
        id: 293,

        title: 'Guarana Magic - скраб',
        desc_short:
            'Легкая комфортная основа из 5 насыщенных масел содержит мелкие кристаллы соли и грецкого ореха для тщательного и нежного отшелушивания, выведения токсинов и выравнивания рельефа кожи.',
        desc: '98% компонентов натурального происхождения. Легкая комфортная основа из 5 насыщенных масел содержит мелкие кристаллы соли и грецкого ореха для тщательного и нежного отшелушивания, выведения токсинов и выравнивания рельефа кожи. Скраб предназначен для борьбы с целлюлитом и профилактикой растяжек. Мельчайший абразив скорлупы грецкого ореха и частицы соли сохраняют свою форму во время массажа, бережно удаляя омертвевшие клетки, но не травмируя кожу. Насыщенная смесь из масел сладкого миндаля, семян подсолнечника, ши и пальмоядрового обеспечивает полноценное питание и увлажнение. Комплекс из масла кофе, экстрактов гуараны и имбиря улучшает микроциркуляцию крови в тканях, за счет чего выводит лишнюю жидкость из подкожного слоя. В результате, ускоряются обменные процессы в клетках и начинается активный процесс расщепления жира. Эффект этих ингредиентов заключается в липолизе жировой ткани, стимуляции периферической микроциркуляции для облегчения лимфатического дренажа и уменьшении отеков. Кожа становится более ровной и гладкой, обновленной и обеспечивается профилактика ”апельсиновой корки”.',

        count: 1,

        weight: 250,
        weightType: 'Г',
        cost: 1090,
        categories: 'Бестселлеры, Новинки',
        imageUrl: 'https://1790009369.rsc.cdn77.org/images/3-2.png',
        zagolovok_sostava: 'Состав скраба',
        sostav: 'Sodium Chloride, Juglans Regia (Walnut) Shell Powder, Isopropyl Palmitate, Тосоpherol, Elaeis Guineensis Kernel Oil, Helianthus Annuus Seed Oil, Cocos Nucifera (Coconut) Oil, Phenoxyethanol, Ethylhexylglycerin, Parfum, Butyrospermum Parkii (Shea) Butter, Prunus Amygdalus Dulcis (Sweet Almond) Oil, Coffea Arabica (Coffee) Seed Oil, Paullinia Cupana (Guarana) Seed Extract, Zingiber Officinale (Ginger) Extract',
        blok_rekomendaciya_zagolovok: 'РЕКОМЕНДУЕТ ИМЕННО ЭТОТ ПРОДУКТ?',

        blok_rekomendaciya_podpis_k_zagolovku: 'ПОЧЕМУ ЛИЗА МИЛЛЕР',

        blok_rekomendaciya_kontent:
            'Нежная прохладная гелевая текстура виноградного обёртывания обеспечит интенсивный уход за кожей тела и продлит её молодость.Насыщенный состав позволит быстро уменьшить объёмы в «проблемных зонах», подтянуть и тонизировать кожу. Регулярное использование обёртывания сделает кожу гладкой и упругой',

        blok_rekomendaciya_ikonka_v_ramke: null,

        blok_rekomendaciya_zagolovok_v_ramke: null,

        blok_rekomendaciya_opisanie_v_ramke: null,

        blok_effekt_zagolovok: 'Эффект',

        blok_ingredienty_zagolovok: 'ДЕЙСТВУЮЩИЕ ИНГРЕДИЕНТЫ',

        blok_ingredienty_ingredient_1: 'ГРЕЦКИЙ ОРЕХ',

        blok_ingredienty_ingredient_2: 'СОЛЬ',

        blok_ingredienty_ingredient_3: 'СЛАДКИЙ МИНДАЛЬ',

        blok_ingredienty_ingredient_4: 'ПОДСОЛНЕЧНИК',

        blok_ingredienty_ingredient_5: 'МАСЛО ШИ',

        blok_ingredienty_ingredient_6: 'ГУАРАНА',

        blok_ingredienty_ingredient_7: 'ИМБИРЬ',

        blok_primenenie_kontent:
            'Нанести небольшое количество скраба на влажную кожу. В течение 2 минут массировать легкими круговыми восходящими движениями, по направлению тока лимфы для улучшения обменных процессов в коже. После процедуры смыть средство теплой водой.',

        blok_primenenie_video: {
            field_61c8ce8185dd7: null
        },

        blok_do_i_posle_zagolovok: null,

        blok_effekt_dobavit_effekt_0_effekt: 'Увлажняет и разглаживает кожу, очищает поры',

        blok_effekt_dobavit_blok_effekta_0_img: 'https://1790009369.rsc.cdn77.org/images/oreh-gretskii--150x150.jpeg',
        blok_effekt_dobavit_blok_effekta_1_img: 'https://1790009369.rsc.cdn77.org/images/kofe-maslo--150x150.jpeg',
        blok_effekt_dobavit_blok_effekta_2_img: 'https://1790009369.rsc.cdn77.org/images/imbir.png',

        blok_effekt_dobavit_effekt_1_effekt: 'Способствует активному процессу расщепления жира',

        blok_effekt_dobavit_effekt_2_effekt: 'Убирает "апельсиновую" корку',

        blok_effekt_dobavit_blok_effekta_0_zagolovok: 'Безопасное скрабирование',

        blok_effekt_dobavit_blok_effekta_0_opisanie: 'Скорлупа грецкого ореха оказывает мягкое эксфолиирующее',

        blok_effekt_dobavit_blok_effekta_1_zagolovok: 'Гладкая кожа без бугристости',

        blok_effekt_dobavit_blok_effekta_1_opisanie:
            'В составе масло кофе, которое помогает расщеплять жиры в коже, а также разглаживает ее, убирая «апельсиновые» бугорочки, делая кожу гладкой и матовой.',

        postoyannye_dannye_zagolovok_sostava: 'Состав крема',
        postoyannye_dannye_podpis_sostav: 'Посмотрите состав крема, нажав на кнопку',
        postoyannye_dannye_podpis_vesa: 'Вес упаковки',

        naznachenie_tovara: 'Антицеллюлитный скраб для тела',
        podpis_v_hlebnyh_kroshkah: 'Guarana Magic',

        blok_otzyvy_zagolovok: 'Отзывы наших клиентов',

        blok_effekt_dobavit_blok_effekta_2_zagolovok: 'Локальное похудение',

        blok_effekt_dobavit_blok_effekta_2_opisanie:
            'Совместно с экстрактом имбиря кофе улучшает микроциркуляцию крови в тканях, за счет чего выводит лишнюю жидкость из подкожного слоя. В результате, ускоряются обменные процессы в клетках и начинается активный процесс расщепления жира. Эффект этих ингредиентов заключается в липолизе жировой ткани, стимуляции периферической микроциркуляции для облегчения лимфатического дренажа и уменьшении отеков.',

        postoyannye_dannye_podpis_obema: 'Объем упаковки'
    },
    {
        id: 319,

        title: 'Chili Magic - крем + ролик',
        desc_short: null,
        desc: 'Средство для антицеллюлитного обертывания или массажа, предотвращает появления растяжек и целлюлита, в комплексе с другими процедурами является активным средством по борьбе с несовершенствами кожи и поддержанием ее здорового состояния. Хорошо разогревает кожу, улучшает кровообращение, стимулирует выравнивание кожи. Для всех типов кожи, для зонального применения. Разогревающий эффект. Смягчение, стимуляция кожи. Аромат: лайм и ваниль. Не рекомендуется использовать во время беременности и лактации',

        count: 1,

        weight: 290,
        weightType: 'Г',
        cost: 1990,
        categories: 'Антицеллюлитные средства, Для рук и ног, Для тела',
        imageUrl: 'https://1790009369.rsc.cdn77.org/images/tovar-5.png',
        zagolovok_sostava: 'Состав крема',
        sostav: 'Aqua,Triticumvulgare(Wheat)Germoil, ButyrospermumParkii(Shea)oil,Glycerin(Vegetable), Cetearyl Alcohol, Polysorbate 60, Theobroma Cacao (Cocoa) Seed Butter, Vitis Vinifera (Grape) Seed Oil, Coffea Arabica (Coffee) Seed oil, Colloidal Gold, Capsicum Annuum Extract, Glyceryl Stearate, Palmitic Acid, Cellulose Gum, Laminaria Extract, Isopropyl Palmitate, Carbomer, Dehydroacetic Acid, Benzyl Alcohol, Disodium Edta, Sodium Hydroxide, Fragrance.',
        blok_rekomendaciya_zagolovok: 'РЕКОМЕНДУЕТ ИМЕННО ЭТОТ ПРОДУКТ?',

        blok_rekomendaciya_podpis_k_zagolovku: 'ПОЧЕМУ ЛИЗА МИЛЛЕР',

        blok_rekomendaciya_kontent:
            'Нежная прохладная гелевая текстура виноградного обёртывания обеспечит интенсивный уход за кожей тела и продлит её молодость\n\n&nbsp;\n\nНасыщенный состав позволит быстро уменьшить объёмы в «проблемных зонах», подтянуть и тонизировать кожу. Регулярное использование обёртывания сделает кожу гладкой и упругой',

        blok_rekomendaciya_ikonka_v_ramke: 143,

        blok_rekomendaciya_zagolovok_v_ramke: 'Полифенолы, содержащиеся в виноградной косточке',

        blok_rekomendaciya_opisanie_v_ramke: 'являются одними из самых мощных антиоксидантов растительного происхождения',

        blok_effekt_zagolovok: 'Эффект',

        blok_ingredienty_zagolovok: 'ДЕЙСТВУЮЩИЕ ИНГРЕДИЕНТЫ',

        blok_ingredienty_ingredient_1: 'Нанокомплекс Coreshell: Коллоидное Золото + Капсаицин',

        blok_ingredienty_ingredient_2: 'Масло зародышей пшеницы',

        blok_ingredienty_ingredient_3: 'Масло Ши',

        blok_ingredienty_ingredient_4: 'Масло какао',

        blok_ingredienty_ingredient_5: 'Масло кофе',

        blok_ingredienty_ingredient_6: 'Экстракт Ламинарии',

        blok_ingredienty_ingredient_7: 'Пальмитиновая кислота',

        blok_primenenie_kontent:
            'Нанести небольшое количество крема на проблемные участки бедер, ягодиц, живота, растереть крем по массажным линиям и сделать массаж с помощью ролика. Важно! Крем нельзя смывать ранее, чем через 30 минут после нанесения, так как может появиться сильное жжение',

        blok_do_i_posle_zagolovok: 'А так же до/после',

        blok_effekt_dobavit_effekt_0_effekt: 'УМЕНЬШАЕТ ОБЪЕМЫ В ПРОБЛЕМНЫХ ЗОНАХ',

        blok_effekt_dobavit_blok_effekta_0_img: 'https://1790009369.rsc.cdn77.org/images/Groaup-89.png',
        blok_effekt_dobavit_blok_effekta_1_img: 'https://1790009369.rsc.cdn77.org/images/Group-d9.png',
        blok_effekt_dobavit_blok_effekta_2_img: null,

        blok_effekt_dobavit_effekt_1_effekt: 'НАСЫЩАЕТ КОЖУ ВИТАМИНАМИ И МИКРОЭЛЕМЕНТАМИ',

        blok_effekt_dobavit_effekt_2_effekt: 'ПРОДЛЕВАЕТ МОЛОДОСТЬ',

        blok_effekt_dobavit_blok_effekta_0_zagolovok:
            'Экстракт винограда позволяет эффективно увлажнить кожу и способствует выведению шлаков',

        blok_effekt_dobavit_blok_effekta_1_zagolovok: 'Ролик добавляет эффект упругости и подтянутости',

        postoyannye_dannye_zagolovok_sostava: 'Состав крема',
        postoyannye_dannye_podpis_sostav: 'Посмотрите состав крема, нажав на кнопку',
        postoyannye_dannye_podpis_vesa: 'Вес упаковки',
        postoyannye_dannye_zagolovok_kompleks: 'Целый комплекс',
        postoyannye_dannye_podpis_kompleks: 'В набор входит ролик и крем для ухода за собой',

        naznachenie_tovara: 'Антицеллюлитный крем обертывание для массажа роликом',
        podpis_v_hlebnyh_kroshkah: 'Chili Magic',

        blok_otzyvy_zagolovok: 'Отзывы наших клиентов',

        postoyannye_dannye_podpis_obema: 'Объем упаковки'
    },
    {
        id: 405,

        title: 'Air mango - крем-баттер для тела 11 масел',
        desc_short: null,
        desc: '99% компонентов натурального происхождения. Воздушный баттер для тела с комплексом из 11 ценных растительных масел предназначен для глубокого увлажнения кожи, повышения эластичности, с целью борьбы с растяжками и предотвращения их появления.Благодаря высокому содержанию насыщенных и ненасыщенных жирных кислот масла Авокадо, Миндаля, Подсолнечника и Рисовых Отрубей питают, увлажняют кожу, снижая ощущение стянутости. Масло Виноградной косточки и Пальмоядровое, а также экстракты Амаранта и Розмарина способствует усилению регенерации, замедляют процесс старения. Витамин Е улучшает тонус, гладкость кожи, придает ей сияние и здоровый вид. Баттер идеально подходит для лифтингового ухода за кожей тела день за днём.',

        count: 1,

        weight: 200,
        weightType: 'мл',
        cost: 1290,
        categories: 'Для тела, Новинки',
        imageUrl: 'https://1790009369.rsc.cdn77.org/images/Glavnyi-komponent-tovara-foto-1-1.png',

        Апсейл: 'id:259',
        Кросселы: 'id:278',

        zagolovok_sostava: 'Состав крема',
        sostav: 'Butyrospermum Parkii (Shea) Oil, Elaeis Guineensis (Palm) Kernel Oil, Cocos Nucifera (Coconut) Oil, Helianthus Annuus (Sunflower) Seed Oil, Tocopherol, Parfum, Mangifera Indica (Mango) Seed Oil, Oryza Sativa (Rice) Germ Oil, Theobroma Cacao (Cocoa) Seed Butter, Persea Gratissima (Avocado) Oil, Prunus Amygdalus Dulcis (Sweet Almond) Oil, Vitis Vinifera (Grape) Seed Oil, Olea Europaea (Olive) Oil, Amaranthus Caudatus (Amaranth) Seed Extract, Rosmarinus Officinalis (Rosemary) Leaf Extract',
        blok_rekomendaciya_zagolovok: 'РЕКОМЕНДУЕТ ИМЕННО ЭТОТ ПРОДУКТ?',

        blok_rekomendaciya_podpis_k_zagolovku: 'ПОЧЕМУ ЛИЗА МИЛЛЕР',

        blok_effekt_zagolovok: 'Эффект',

        blok_ingredienty_zagolovok: 'ДЕЙСТВУЮЩИЕ ИНГРЕДИЕНТЫ',

        blok_ingredienty_ingredient_1: 'МАСЛО ШИ',

        blok_ingredienty_ingredient_2: 'КОКОСОВОЕ МАСЛО',

        blok_ingredienty_ingredient_3: 'МАСЛО МАНГО',

        blok_ingredienty_ingredient_4: 'РИСОВОЕ МАСЛО',

        blok_ingredienty_ingredient_5: 'МАСЛО АВОКАДО',

        blok_ingredienty_ingredient_6: 'АМАРАНТОВОЕ МАСЛО',

        blok_ingredienty_ingredient_7: 'МАСЛО КАКАО',

        blok_primenenie_kontent: 'Нанести небольшое количество баттера на кожу, распределить мягкими массирующими движениями.',

        blok_effekt_dobavit_effekt_0_effekt: 'Гладкая и упругая кожа',

        blok_effekt_dobavit_blok_effekta_0_img: 'https://1790009369.rsc.cdn77.org/images/c25f9b145d8f6637be57a95f30b0aa0b.png',
        blok_effekt_dobavit_blok_effekta_1_img: 'https://1790009369.rsc.cdn77.org/images/c25f9b145d8f6637be57a95f30b0aa0b.png',
        blok_effekt_dobavit_blok_effekta_2_img: 'https://1790009369.rsc.cdn77.org/images/free-png.ru-34-300x300.png',

        blok_effekt_dobavit_effekt_1_effekt: 'Глубокое питание',

        blok_effekt_dobavit_effekt_2_effekt: 'Выраженный anti-age эффект',

        blok_effekt_dobavit_blok_effekta_0_zagolovok:
            'Питательные масла Ши, Кокоса, Манго, Оливы и Какао быстро улучшают состояние кожного покрова, усиливают упругость и плотность кожи.',

        blok_effekt_dobavit_blok_effekta_1_zagolovok:
            'Масла Авокадо, Миндаля, Подсолнечника и Рисовых Отрубей питают, увлажняют кожу, снижая ощущение стянутости.',

        postoyannye_dannye_zagolovok_sostava: 'Состав баттера',
        postoyannye_dannye_podpis_sostav: 'Посмотрите состав баттера, нажав на кнопку',
        postoyannye_dannye_podpis_vesa: 'Вес упаковки',

        naznachenie_tovara: 'Увлажянющий баттер',
        podpis_v_hlebnyh_kroshkah: 'Mango air - роскошный баттер',

        blok_otzyvy_zagolovok: 'Отзывы наших клиентов',

        blok_effekt_dobavit_blok_effekta_2_zagolovok:
            'Масло Виноградной косточки и Пальмоядровое, а также экстракты Амаранта и Розмарина способствует усилению регенерации, замедляют процесс старения.',

        postoyannye_dannye_podpis_obema: 'Объем упаковки'
    },
    {
        id: 406,

        title: 'Watermelon milk - молочко для душа',
        desc_short: null,
        desc: 'Мягкое очищающее средство подходит для ежедневного очищения кожи тела. При контакте с водой молочно-масляная формула превращается в мыльную пену, тщательно удаляя все загрязнения и раскрываясь ароматом спелого арбуза, оставляет кожу невероятно гладкой и шелковистой. Гель для душа содержит масло авокадо, естественно богатое лецитином и антиоксидантами, которые помогают успокоить и восстановить тонус кожи. Растительный глицерин и масло зародышей пшеницы оказывают интенсивное питательное, увлажняющее и смягчающее действие. В результате кожа становится идеально чистой и гладкой.',

        count: 1,

        weight: 300,
        weightType: 'Г',
        cost: 690,
        categories: 'Новинки',
        imageUrl: 'https://1790009369.rsc.cdn77.org/images/Glavnyj-komponent-tovara-foto-1-1.png',
        zagolovok_sostava: 'Состав геля для душа',
        sostav: 'Состав/INCI: Aqua, Sodium Laureth Sulfate, Cocamidopropyl Betaine, Decyl Glucoside, Cocamide DEA, Sodium Chloride, Panthenol, Polyquaternium-7, Glycerin, Fragrance, Triticum Vulgare (Wheat) Germ Oil, Persea Gratissima (Avocado) Oil, Coco Glucoside, Citric Acid, PEG-7 Glyceryl Cocoate, Tetrasodium EDTA, Styrene/Acrylates Copolymer, Chloromethylisothiazolinone, Methylisothiazolinone',
        blok_rekomendaciya_zagolovok: 'РЕКОМЕНДУЕТ ИМЕННО ЭТОТ ПРОДУКТ?',

        blok_rekomendaciya_podpis_k_zagolovku: 'ПОЧЕМУ ЛИЗА МИЛЛЕР',

        blok_effekt_zagolovok: 'Эффект',

        blok_effekt_ikonka: null,

        blok_effekt_opisanie_sverhu: null,

        blok_effekt_opisanie_snizu: null,

        blok_effekt_dobavit_effekt: 2,

        blok_ingredienty_zagolovok: 'ДЕЙСТВУЮЩИЕ ИНГРЕДИЕНТЫ',

        blok_ingredienty_ingredient_1: 'МАСЛО АВОКАДО',

        blok_ingredienty_ingredient_2: 'РАСТИТЕЛЬНЫЙ ГЛИЦЕРИН',

        blok_ingredienty_ingredient_3: null,

        blok_ingredienty_ingredient_4: 'АНТИОКСИДАНТЫ',

        blok_ingredienty_ingredient_5: null,

        blok_ingredienty_ingredient_6: 'МАСЛО ЗАРОДЫШЕЙ ПШЕНИЦЫ',

        blok_ingredienty_ingredient_7: null,

        blok_primenenie_kontent: 'Нанести небольшое количество молочка на влажную кожу массажными движениями, смыть водой',

        blok_do_i_posle_zagolovok: 'А так же до/после',

        blok_effekt_dobavit_effekt_0_effekt: 'Оставляет кожу невероятно гладкой и шелковистой',

        blok_effekt_dobavit_blok_effekta_0_img: 'https://1790009369.rsc.cdn77.org/images/avocado-emoji.png',
        blok_effekt_dobavit_blok_effekta_1_img: 'https://1790009369.rsc.cdn77.org/images/arbuz-256x256-1.png',
        blok_effekt_dobavit_blok_effekta_2_img: null,

        blok_effekt_dobavit_effekt_1_effekt: 'Интенсивное питательное, увлажняющее и смягчающее действие',

        blok_effekt_dobavit_blok_effekta_0_zagolovok:
            'содержит масло авокадо, естественно богатое лецитином и антиоксидантами, которые помогают успокоить и восстановить тонус кожи',

        blok_effekt_dobavit_blok_effekta_1_zagolovok:
            'При контакте с водой молочно-масляная формула превращается в мыльную пену, тщательно удаляя все загрязнения и раскрываясь ароматом спелого арбуза',

        postoyannye_dannye_zagolovok_sostava: 'Состав геля',
        postoyannye_dannye_podpis_sostav: 'Посмотрите состав геля, нажав на кнопку',
        postoyannye_dannye_podpis_vesa: 'Вес упаковки',

        naznachenie_tovara: 'Нежное молочко для душа',

        blok_otzyvy_zagolovok: 'Отзывы наших клиентов',

        postoyannye_dannye_podpis_obema: 'Объем упаковки'
    },
    {
        id: 407,
        title_short: 'Foot Professional',
        title: 'Foot Professional - набор для домашнего педикюра',

        desc_short: null,
        desc: 'Набор для профессионального педикюра включает в себя: Флюид - жидкое лезвие для профессионального педикюра. Профессиональная терка для обработки стоп с двумя рабочими поверхностями, каждая из которых имеет абразивность. Крем-бальзам для ног "Анти-трещины"',

        count: 1,

        weight: 600,
        weightType: 'Г',
        cost: 990,
        categories: 'Для рук и ног, Новинки',
        imageUrl: 'https://1790009369.rsc.cdn77.org/images/Glavnyi-komponent-tovara-foto-4.png',
        zagolovok_sostava: 'Состав средств',
        sostav: 'Флюид "Жидкое лезвие" Состав/INCI: Aqua, Urea, Glycerin, Aloe Barbadensis (Aloe Vera) Leaf Gel, Persea Gratissima (Avocado) Oil, Cellulose Gum, Glycolic Acid, Sodium Hydroxide\nКрем для ног "Анти-трещины" Состав/INCI: Aqua, Elaeis Guineensis (Palm) Kernel Oil, Glycerin, Helianthus Annuus (Sunflower) Seed Oil, Propylene Glycol, Cetearyl Alcohol, Polysorbate 60, Тосоpherol, Colloidal Silver, Palmitic Acid, Stearic Acid, Dimethicone, Carbomer, PEG-12 Dimethicone, Fragrance, Butyrospermum Parkii (Shea) Oil, Cocos Nucifera (Coconut) Oil, Niacinamide, Panthenol, Dehydroacetic Acid, Benzyl Alcohol, Tetrasodium EDTA, Sodium Hydroxide',
        blok_rekomendaciya_zagolovok: 'РЕКОМЕНДУЕТ ИМЕННО ЭТОТ ПРОДУКТ?',

        blok_rekomendaciya_podpis_k_zagolovku: 'ПОЧЕМУ ЛИЗА МИЛЛЕР',

        blok_effekt_zagolovok: 'Эффект',

        blok_ingredienty_zagolovok: 'ДЕЙСТВУЮЩИЕ ИНГРЕДИЕНТЫ',

        blok_ingredienty_ingredient_1: 'МОЧЕВИНА',

        blok_ingredienty_ingredient_2: 'КОЛЛОИДНОЕ СЕРЕБРО',

        blok_ingredienty_ingredient_3: 'ПАНТЕНОЛ',

        blok_ingredienty_ingredient_4: 'МАСЛО ШИ',

        blok_ingredienty_ingredient_5: 'МАСЛО КОКОСА',

        blok_ingredienty_ingredient_6: 'ГЛИКОЛЕВАЯ КИСЛОТА',

        blok_ingredienty_ingredient_7: 'ГЕЛЬ АЛОЭ',

        blok_primenenie_kontent:
            'Нанести средство на ватный диск, плотно приложить на проблемные участки стоп, остановить на 3-5 минут. Размягченную кожу тщательно обработать педикюрной теркой в течение 2-3 минут. Промыть обработанные участки с мылом и нанести крем-бальзам Анти-трещины',

        blok_do_i_posle_zagolovok: 'А так же до/после',

        blok_effekt_dobavit_effekt_0_effekt:
            'Средство для простого и быстрого ухода за сухой и потрескавшейся кожей стоп и пяток. Заменяет процедуру распаривания кожи, в комплексе с скребком-пилкой позволяет удалить ороговевшую кожу со ступней за несколько минут.',

        blok_effekt_dobavit_blok_effekta_0_img:
            'https://1790009369.rsc.cdn77.org/images/230-2308810_silver-element-silver-periodic-table-symbol.png',
        blok_effekt_dobavit_blok_effekta_1_img: 'https://1790009369.rsc.cdn77.org/images/c25f9b145d8f6637be57a95f30b0aa0b.png',
        blok_effekt_dobavit_blok_effekta_2_img: 'https://1790009369.rsc.cdn77.org/images/1367609891493a16f17473155f517a6e-150x150.jpeg',

        blok_effekt_dobavit_effekt_1_effekt: 'Пилка-терка мягко, но эффективно убирает омертвевшую кожу',

        blok_effekt_dobavit_effekt_2_effekt:
            'Восстанавливающий крем-бальзам с нежирной, но питательной формулой эффективно увлажняет сухую огрубевшую кожу ног. Может использоваться как самостоятельное средство и как 3 этап трехступенчатой системы ухода за сухими',

        blok_effekt_dobavit_blok_effekta_0_zagolovok:
            'Уникальная формула с технологией Coreshell Коллоидным Серебром, Пантенолом (витамином В5) и Ниацинамидом (витамином В3) способствует восстановлению и укреплению защитного кожного барьера, обеспечивая антибактериальный эффект и поддерживая длительную свежесть.',

        blok_effekt_dobavit_blok_effekta_1_zagolovok:
            'Для смягчения, разглаживания шероховатостей и поддержания естественного уровня увлажнения кожи используются питательное масло Ши, Кокоса, Пальмоядровое и растительный Глицерин.',

        postoyannye_dannye_zagolovok_sostava: 'Состав средств',
        postoyannye_dannye_podpis_sostav: 'Посмотрите состав средств, нажав на кнопку',
        postoyannye_dannye_podpis_vesa: 'Вес упаковки',
        postoyannye_dannye_zagolovok_kompleks: 'Целый комплекс',
        postoyannye_dannye_podpis_kompleks: 'В набор входит флюид, пилка-терка для ног, крем для ног',

        naznachenie_tovara: 'Профессиональный домашний педикюр',

        blok_otzyvy_zagolovok: 'Отзывы наших клиентов',

        blok_effekt_dobavit_blok_effekta_2_zagolovok:
            'Высокая концентрация Мочевины обеспечивает сильный кератолитический эффект. В сочетании с растительным Глицерином и Гликолевой кислотой ослабляет межклеточные соединения плотных слоев кожи, размягчает ороговевшую ткань стоп, натоптышей и мозолей до состояния, когда она легко удаляется скребком-пилкой.',

        postoyannye_dannye_podpis_obema: 'Объем упаковки'
    },
    {
        id: 7732,

        title: 'Rose Gold - тоник-мист для лица',
        desc_short: null,
        desc: 'Нанести средсво на лицо, протереть ватным диском, использовать следующий этап ухода',

        count: 1,

        weight: 200,
        weightType: 'Г',
        cost: 890,
        categories: 'Для лица, Новинки',
        imageUrl: 'https://1790009369.rsc.cdn77.org/images/2.png',
        zagolovok_sostava: 'Состав крема',
        sostav: 'Состав/INCI: Aqua, Colloidal Gold, Rhodiola Rosea Root Extract, Glycerin, Panthenol, Trifolium Pratense (Red Clover) Extract, Hydrolyzed Collagen, Allantoin, Sodium Hyaluronate, Inulin, Dehydroacetic Acid, Benzyl Alcohol, Tetrasodium EDTA, Fragrance',
        blok_rekomendaciya_zagolovok: 'РЕКОМЕНДУЕТ ИМЕННО ЭТОТ ПРОДУКТ?',

        blok_rekomendaciya_podpis_k_zagolovku: 'ПОЧЕМУ ЛИЗА МИЛЛЕР',

        blok_effekt_zagolovok: 'Эффект',

        blok_ingredienty_zagolovok: 'ДЕЙСТВУЮЩИЕ ИНГРЕДИЕНТЫ',

        blok_ingredienty_ingredient_1: 'КОЛЛОИДНОЕ ЗОЛОТО',

        blok_ingredienty_ingredient_2: 'КОЛЛАГЕН',

        blok_ingredienty_ingredient_3: 'РОДИОЛА РОЗОВАЯ',

        blok_ingredienty_ingredient_4: 'ЭКСТРАКТ КЛЕВЕРА',

        blok_ingredienty_ingredient_5: 'ГИАЛУРОНОВАЯ КИСЛОТА',

        blok_ingredienty_ingredient_6: 'АЛЛАНТОИН',

        blok_ingredienty_ingredient_7: 'ИНУЛИН',

        blok_primenenie_kontent:
            'Нанести небольшое количество средства на кожу, протереть кожу ватным диском. Можно использовать следующий этап ухода.',

        blok_do_i_posle_zagolovok: 'А так же до/после',

        blok_effekt_dobavit_effekt_0_effekt: 'Увлажненная сияющая кожа',

        blok_effekt_dobavit_blok_effekta_0_img: 'https://1790009369.rsc.cdn77.org/images/gold-texture.jpeg',
        blok_effekt_dobavit_blok_effekta_1_img: 'https://1790009369.rsc.cdn77.org/images/pngtree-rhodiola-rosea-image_2225164-1.jpeg',
        blok_effekt_dobavit_blok_effekta_2_img: 'https://1790009369.rsc.cdn77.org/images/images.jpeg',

        blok_effekt_dobavit_effekt_1_effekt: 'Цвет лица более гладкий, мягкий и здоровый',

        blok_effekt_dobavit_effekt_2_effekt: 'Гладкая кожа',

        blok_effekt_dobavit_blok_effekta_0_zagolovok: 'Коллоидное золото',

        blok_effekt_dobavit_blok_effekta_0_opisanie: 'способствует глубокому проникновению питательных веществ и омолаживает кожу',

        blok_effekt_dobavit_blok_effekta_1_zagolovok: 'Родиола розовая',

        blok_effekt_dobavit_blok_effekta_1_opisanie:
            'стимулирует обменные процессы, повышает защитные функции кожи и сопротивляемость внешним воздействиям, насыщает кожу витаминами.',

        postoyannye_dannye_zagolovok_sostava: 'Состав тоника',
        postoyannye_dannye_podpis_sostav: 'Посмотрите состав тоника, нажав на кнопку',
        postoyannye_dannye_podpis_vesa: 'Вес упаковки',

        blok_otzyvy_zagolovok: 'Отзывы наших клиентов',

        blok_effekt_dobavit_blok_effekta_2_zagolovok: 'Клевер',

        blok_effekt_dobavit_blok_effekta_2_opisanie: 'устраняет морщины и успокаивает кожу',

        postoyannye_dannye_podpis_obema: 'Объем упаковки'
    },
    {
        id: 7741,

        title: 'Triple Action - Мягкая мицеллярная вода тройного действия',
        desc_short: null,
        desc: '96% компонентов натурального происхождения. Мягкое мицеллярное средство 3-в-1 эффективно удаляет макияж, одновременно очищая кожу от загрязнений и излишков себума, не лишая кожу естественного увлажнения и не нарушая водно-липидный баланс. Подходит для всех типов кожи, позволяет тщательно и бережно удалять ежедневный макияж с кожи, безопасно для всего лица, включая глаза и губы. Содержит комплекс с гиалуроновой кислотой, экстракт грейпфрута, масло авокадо и жожоба, что позволяет мягко очищать кожу, не лишая ее влаги, оставляя кожу чистой, мягкой и эластичной.',

        count: 1,

        weight: 200,
        weightType: 'Г',
        cost: 890,
        categories: 'Для лица, Новинки',
        imageUrl: 'https://1790009369.rsc.cdn77.org/images/3.png',
        zagolovok_sostava: 'Состав мицеллярной воды',
        sostav: 'Состав/INCI: Aqua, Cocamidopropyl Betaine, Sodium Lauroyl Sarcosinate, Dehydroacetic Acid, Benzyl Alcohol, Poloxamer 184, Propylene Glycol, Colloidal Gold, Sodium hyaluronate, Persea Gratissima (Avocado) Oil, Citrus Paradisi (Grapefruit) Peel Extract, Simmondsia Chinensis (Jojoba) Seed Oil, Sorbitol, Tetrasodium EDTA, Fragrance',
        blok_rekomendaciya_zagolovok: 'РЕКОМЕНДУЕТ ИМЕННО ЭТОТ ПРОДУКТ?',

        blok_rekomendaciya_podpis_k_zagolovku: 'ПОЧЕМУ ЛИЗА МИЛЛЕР',

        blok_effekt_zagolovok: 'Эффект',

        blok_ingredienty_zagolovok: 'ДЕЙСТВУЮЩИЕ ИНГРЕДИЕНТЫ',

        blok_ingredienty_ingredient_1: 'КОЛЛОИДНОЕ ЗОЛОТО',

        blok_ingredienty_ingredient_2: 'ГИАЛУРОНОВАЯ КИСЛОТА',

        blok_ingredienty_ingredient_3: null,

        blok_ingredienty_ingredient_4: 'МАСЛО АВОКАДО',

        blok_ingredienty_ingredient_5: 'ЭКСТРАКТ ГРЕЙПФРУТА',

        blok_ingredienty_ingredient_6: null,

        blok_ingredienty_ingredient_7: null,

        blok_primenenie_kontent:
            'Нанести небольшое количество средства на кожу, протереть кожу ватным диском. Мицеллярную воду обязательно необходимо смыть с помощью средства для умывания.',

        blok_do_i_posle_zagolovok: 'А так же до/после',

        blok_effekt_dobavit_effekt_0_effekt: 'Эффективно удаляет макияж',

        blok_effekt_dobavit_blok_effekta_0_img: 'https://1790009369.rsc.cdn77.org/images/gold-texture.jpeg',
        blok_effekt_dobavit_blok_effekta_1_img: 'https://1790009369.rsc.cdn77.org/images/dizayn-bez-nazvaniya-17.jpeg',
        blok_effekt_dobavit_blok_effekta_2_img: 'https://1790009369.rsc.cdn77.org/images/avocado-emoji.png',

        blok_effekt_dobavit_effekt_1_effekt: 'Подходит для кожи глаз и губ',

        blok_effekt_dobavit_effekt_2_effekt: 'Не нарушает баланс кожи',

        blok_effekt_dobavit_blok_effekta_0_zagolovok: 'КОЛЛОИДНОЕ ЗОЛОТО',

        blok_effekt_dobavit_blok_effekta_0_opisanie: 'способствует глубокому проникновению питательных веществ и омолаживает кожу',

        blok_effekt_dobavit_blok_effekta_1_zagolovok: 'ГИАЛУРОНОВАЯ КИСЛОТА',

        blok_effekt_dobavit_blok_effekta_1_opisanie: 'глубоко увлажняет кожу, поддерживает водный баланс',

        postoyannye_dannye_zagolovok_sostava: 'Состав мицеллярной воды',
        postoyannye_dannye_podpis_sostav: 'Посмотрите мицеллярной воды, нажав на кнопку',
        postoyannye_dannye_podpis_vesa: 'Вес упаковки',
        postoyannye_dannye_zagolovok_kompleks: 'Целый',

        blok_otzyvy_zagolovok: 'Отзывы наших клиентов',

        blok_effekt_dobavit_blok_effekta_2_zagolovok: 'МАСЛО АВКОАДО',

        blok_effekt_dobavit_blok_effekta_2_opisanie: 'Восполняет нехватку липидов, увлажняет, смягчает и питает кожу',

        postoyannye_dannye_podpis_obema: 'Объем упаковки'
    },
    {
        id: 7745,

        title: 'GOLD SERUM  сыворотка день+ночь',
        desc_short: null,
        desc: '97% компонентов натурального происхождения. Созданная на основе технологии Nuclear Colloids, сыворотка имеет легкую гелевую текстуру и интенсивную формулу, которая поддерживает уровень влаги в коже, уменьшает появление тонких линий и морщин, делая кожу здоровой, упругой и молодой. Рекомендуется использовать даже при первых возрастных признаках, подходит для всех типов кожи.',

        count: 1,

        weight: 30,
        weightType: 'Г',
        cost: 1190,
        categories: 'Для лица, Новинки',
        imageUrl: 'https://1790009369.rsc.cdn77.org/images/MILLIDZH-SYVOROTKA-MOKAP-kopiya.png',
        zagolovok_sostava: 'Состав сыворотки',
        sostav: 'Состав/INCI: Aqua, Colloidal Gold, Glycerin, Rhodiola Rosea Root Extract, Cellulose Gum, Tocopherol (Vitamin E), Prunus Amygdalus Dulcis (Sweet Almond) Oil, Niacinamide, Sodium Hydroxide, Sodium Hyaluronate, Carbomer, Phenoxyethanol, Polysorbate-20, Ethylhexylglycerin, Tetrasodium EDTA, Fragrance',
        blok_rekomendaciya_zagolovok: 'РЕКОМЕНДУЕТ ИМЕННО ЭТОТ ПРОДУКТ?',

        blok_rekomendaciya_podpis_k_zagolovku: 'ПОЧЕМУ ЛИЗА МИЛЛЕР',

        blok_effekt_zagolovok: 'Эффект',

        blok_ingredienty_zagolovok: 'ДЕЙСТВУЮЩИЕ ИНГРЕДИЕНТЫ',

        blok_ingredienty_ingredient_1: 'КОЛЛОИДНОЕ ЗОЛОТО',

        blok_ingredienty_ingredient_2: 'ГИАЛУРОНОВАЯ КИСЛОТА',

        blok_ingredienty_ingredient_3: 'НИАЦИМИД',

        blok_ingredienty_ingredient_4: 'РОДИОЛА РОЗОВАЯ',

        blok_ingredienty_ingredient_5: 'МАСЛО МИНДАЛЯ',

        blok_ingredienty_ingredient_6: 'ВИТАМИН Е',

        blok_ingredienty_ingredient_7: null,

        blok_primenenie_kontent:
            'Нанести небольшое количество средства на кожу с помощью пипетки, сделать массаж лица по восходящим линиям. Рекомендуем использовать крем для того, чтобы увеличить эффективность сыворотки.',

        blok_do_i_posle_zagolovok: 'А так же до/после',

        blok_effekt_dobavit_effekt_0_effekt: 'Уменьшает появление тонких линий и морщин',

        blok_effekt_dobavit_blok_effekta_0_img: 'https://1790009369.rsc.cdn77.org/images/dizayn-bez-nazvaniya-17.jpeg',
        blok_effekt_dobavit_blok_effekta_1_img: 'https://1790009369.rsc.cdn77.org/images/gold-texture.jpeg',
        blok_effekt_dobavit_blok_effekta_2_img: 'https://1790009369.rsc.cdn77.org/images/pngtree-rhodiola-rosea-image_2225164-1.jpeg',

        blok_effekt_dobavit_effekt_1_effekt: 'Делает кожу здоровой, упругой и молодой',

        blok_effekt_dobavit_effekt_2_effekt:
            'Ниацинамид и Масло сладкого Миндаля поддерживают здоровый кожный барьер, защищая от свободных радикалов и увлажняя кожу',

        blok_effekt_dobavit_blok_effekta_0_zagolovok: 'ГИАЛУРОНОВАЯ КИСЛОТА',

        blok_effekt_dobavit_blok_effekta_0_opisanie: 'глубоко увлажняет кожу, поддерживает водный баланс',

        blok_effekt_dobavit_blok_effekta_1_zagolovok: 'КОЛЛОИДНОЕ ЗОЛОТО',

        blok_effekt_dobavit_blok_effekta_1_opisanie: 'способствует глубокому проникновению питательных веществ и омолаживает кожу',

        postoyannye_dannye_zagolovok_sostava: 'Состав сыворотки',
        postoyannye_dannye_podpis_sostav: 'Посмотрите состав сыворотки, нажав на кнопку',
        postoyannye_dannye_podpis_vesa: 'Вес упаковки',

        blok_otzyvy_zagolovok: 'Отзывы наших клиентов',

        blok_effekt_dobavit_blok_effekta_2_zagolovok: 'РОДИОЛА РОЗОВАЯ',

        blok_effekt_dobavit_blok_effekta_2_opisanie:
            'стимулирует обменные процессы, повышает защитные функции кожи и сопротивляемость внешним воздействиям, насыщает кожу витаминами.',

        postoyannye_dannye_podpis_obema: 'Объем упаковки'
    },
    {
        id: 7749,
        title: 'SILVER WONDER - Очищающая пенка для умывания',
        desc_short: '',
        desc: '99% компонентов натурального происхождения Нежная бессульфатная пенка предназначена для ежедневного умывания, подходит для всех типов кожи. При контакте с водой состав образует легкую пену, которая быстро растворяется и мягко действует на кожу, эффективно очищает от загрязнений, при этом не нарушает защитный липидный слой.',
        count: 1,
        weight: 150,
        weightType: 'Г',
        cost: 890,
        categories: 'Для лица, Новинки',
        imageUrl: 'https://1790009369.rsc.cdn77.org/images/Novyi-proekt-2-2048x2048.png',
        zagolovok_sostava: 'Состав пенки',
        sostav: 'Состав/INCI: Aqua, Sodium Lauroyl Sarcosinate, Colloidal Silver, Cocamidopropyl Betaine, Centella Asiatica (Gotu Kola) Extract, Panthenol, Aloe barbadensis (Aloe Vera) Leaf Gel, Camellia Sinensis (Green Tea) Leaf Extract,  Dehydroacetic Acid, Benzyl Alcohol, Fragrance',
        blok_rekomendaciya_zagolovok: 'РЕКОМЕНДУЕТ ИМЕННО ЭТОТ ПРОДУКТ?',

        blok_rekomendaciya_podpis_k_zagolovku: 'ПОЧЕМУ ЛИЗА МИЛЛЕР',

        blok_effekt_zagolovok: 'Эффект',

        blok_ingredienty_zagolovok: 'ДЕЙСТВУЮЩИЕ ИНГРЕДИЕНТЫ',

        blok_ingredienty_ingredient_1: 'КОЛЛОИДНОЕ СЕРЕБРО',

        blok_ingredienty_ingredient_2: 'ЦЕНТЕЛЛА АЗИАТСКАЯ',

        blok_ingredienty_ingredient_3: 'ПАНТЕНОЛ',

        blok_ingredienty_ingredient_4: 'ЭКСТРАКТ ЗЕЛЕНОГО ЧАЯ',

        blok_ingredienty_ingredient_5: 'АЛОЭ ГЕЛЬ',

        blok_ingredienty_ingredient_6: 'БЕССУЛЬФАТНАЯ ОСНОВА',

        blok_ingredienty_ingredient_7: null,

        blok_primenenie_kontent: 'Нанести на кожу лица пенку, смыть.',

        blok_do_i_posle_zagolovok: 'А так же до/после',

        blok_effekt_dobavit_effekt_0_effekt: 'Чистая кожа без воспалений',

        blok_effekt_dobavit_blok_effekta_0_img:
            'https://1790009369.rsc.cdn77.org/images/230-2308810_silver-element-silver-periodic-table-symbol.png',
        blok_effekt_dobavit_blok_effekta_1_img: 'https://1790009369.rsc.cdn77.org/images/1367609891493a16f17473155f517a6e-150x150.jpeg',
        blok_effekt_dobavit_blok_effekta_2_img: 'https://1790009369.rsc.cdn77.org/images/img_20180504_063631.jpeg',

        blok_effekt_dobavit_effekt_1_effekt: 'Ровный цвет лица',

        blok_effekt_dobavit_effekt_2_effekt: 'Отсутсвие покраснений и чувства стянутости',

        blok_effekt_dobavit_blok_effekta_0_zagolovok: 'КОЛЛОИДНОЕ СЕРЕБРО',

        blok_effekt_dobavit_blok_effekta_0_opisanie: 'Нормализует выработку кожного себума',

        blok_effekt_dobavit_blok_effekta_1_zagolovok: 'ЦЕНТЕЛЛА АЗИАТСКАЯ',

        blok_effekt_dobavit_blok_effekta_1_opisanie: 'Успокаивает кожу',

        postoyannye_dannye_zagolovok_sostava: 'Состав пенки',
        postoyannye_dannye_podpis_sostav: 'Посмотрите состав пенки, нажав на кнопку',
        postoyannye_dannye_podpis_vesa: 'Вес упаковки',

        blok_otzyvy_zagolovok: 'Отзывы наших клиентов',

        blok_effekt_dobavit_blok_effekta_2_zagolovok: 'АЛОЭ',

        blok_effekt_dobavit_blok_effekta_2_opisanie: 'Увлажняет и убирает вопсплания',

        postoyannye_dannye_podpis_obema: 'Объем упаковки'
    },
    {
        id: 7828,
        title: 'Silver&Gold Face Set',
        title_short: 'Silver&Gold Face Set',
        desc_short: null,
        desc: 'В сет входят: Пенка для лица Silver Wonder, Мицеллярная вода - TRIPLE ACTION, Тоник для лица - Rose gold.ы Сыворотка для лица - Gold day&amp;night',

        count: 1,

        // weight: 200,
        weight: 600,
        weightType: 'Г',
        cost: 3390,
        categories: 'Для лица, Новинки',
        imageUrl: 'https://1790009369.rsc.cdn77.org/images/12_1.png',
        zagolovok_sostava: 'Состав средств',
        sostav: 'Пенка для лица Состав/INCI: Aqua, Sodium Lauroyl Sarcosinate, Colloidal Silver, Cocamidopropyl Betaine, Centella Asiatica (Gotu Kola) Extract, Panthenol, Aloe barbadensis (Aloe Vera) Leaf Gel, Camellia Sinensis (Green Tea) Leaf Extract, Dehydroacetic Acid, Benzyl Alcohol, Fragrance\nМицеллярная вода Состав/INCI: Aqua, Cocamidopropyl Betaine, Sodium Lauroyl Sarcosinate, Dehydroacetic Acid, Benzyl Alcohol, Poloxamer 184, Propylene Glycol, Colloidal Gold, Sodium hyaluronate, Persea Gratissima (Avocado) Oil, Citrus Paradisi (Grapefruit) Peel Extract, Simmondsia Chinensis (Jojoba) Seed Oil, Sorbitol, Tetrasodium EDTA, Fragrance\nТоник для лица Состав/INCI: Aqua, Colloidal Gold, Rhodiola Rosea Root Extract, Glycerin, Panthenol, Trifolium Pratense (Red Clover) Extract, Hydrolyzed Collagen, Allantoin, Sodium Hyaluronate, Inulin, Dehydroacetic Acid, Benzyl Alcohol, Tetrasodium EDTA, Fragrance\n\nСыворотка: Состав/INCI: Aqua, Colloidal Gold, Glycerin, Rhodiola Rosea Root Extract, Cellulose Gum, Tocopherol (Vitamin E), Prunus Amygdalus Dulcis (Sweet Almond) Oil, Niacinamide, Sodium Hydroxide, Sodium Hyaluronate, Carbomer, Phenoxyethanol, Polysorbate-20, Ethylhexylglycerin, Tetrasodium EDTA, Fragrance',
        blok_rekomendaciya_zagolovok: 'РЕКОМЕНДУЕТ ИМЕННО ЭТОТ ПРОДУКТ?',

        blok_rekomendaciya_podpis_k_zagolovku: 'ПОЧЕМУ ЛИЗА МИЛЛЕР',

        blok_effekt_zagolovok: 'Эффект',

        blok_ingredienty_zagolovok: 'ДЕЙСТВУЮЩИЕ ИНГРЕДИЕНТЫ',

        blok_ingredienty_ingredient_1: 'КОЛЛОИДНОЕ ЗОЛОТО',

        blok_ingredienty_ingredient_2: 'ГИАЛУРОНОВАЯ КИСЛОТА',

        blok_ingredienty_ingredient_3: 'РОДИОЛА РОЗОВАЯ',

        blok_ingredienty_ingredient_4: 'АНТИОКСИДАНТЫ',

        blok_ingredienty_ingredient_5: 'ЭКСТРАКТ ГРЕЙПФРУТА',

        blok_ingredienty_ingredient_6: 'АЛЛАНТОИН',

        blok_ingredienty_ingredient_7: 'ИНУЛИН',

        blok_primenenie_kontent:
            'Пенка для лица: мягкими массирующими движениями нанести на влажную кожу небольшое количество пены, смыть водой через 5-20 секунд. Можно использовать для удаления остатков макияжа.\n\nМицеллярная вода: нанесите мицеллярную воду на ватный диск, мягкими движениями удалите макияж с кожи. Приложите ватный диск к закрытым глазам и губам на несколько секунд, затем удалите остатки макияжа. После умойтесь водой, можно использовать очищающую пенку.\n\nТоник для лица: нанести на чистую сухую или влажную кожу лица, шеи и зоны декольте. Подходит для использования утром и вечером.\n\nСыворотка: нанести мягкими похлопывающими движениями на чистую кожу лица, шеи и зоны декольте. Подходит для применения утром и вечером. Поверх сыворотки нанести уходовую маску или крем. Курс рассчитан на  3 месяца.',

        blok_do_i_posle_zagolovok: 'А так же до/после',

        blok_effekt_dobavit_effekt_0_effekt: 'УМЕНЬШАЕТ ПОЯВЛЕНИЕ ТОНКИХ ЛИНИЙ И МОРЩИН',

        blok_effekt_dobavit_blok_effekta_0_img:
            'https://1790009369.rsc.cdn77.org/images/230-2308810_silver-element-silver-periodic-table-symbol.png',
        blok_effekt_dobavit_blok_effekta_1_img: 'https://1790009369.rsc.cdn77.org/images/dizayn-bez-nazvaniya-17.jpeg',
        blok_effekt_dobavit_blok_effekta_2_img: 'https://1790009369.rsc.cdn77.org/images/pngtree-rhodiola-rosea-image_2225164-1.jpeg',

        blok_effekt_dobavit_effekt_1_effekt: 'ДЕЛАЕТ КОЖУ ЗДОРОВОЙ, УПРУГОЙ И МОЛОДОЙ',

        blok_effekt_dobavit_effekt_2_effekt:
            'НИАЦИНАМИД И МАСЛО СЛАДКОГО МИНДАЛЯ ПОДДЕРЖИВАЮТ ЗДОРОВЫЙ КОЖНЫЙ БАРЬЕР, ЗАЩИЩАЯ ОТ СВОБОДНЫХ РАДИКАЛОВ И УВЛАЖНЯЯ КОЖ',

        blok_effekt_dobavit_blok_effekta_0_zagolovok: 'КОЛЛОИДНОЕ ЗОЛОТО',

        blok_effekt_dobavit_blok_effekta_0_opisanie: 'способствует глубокому проникновению питательных веществ и омолаживает кожу',

        blok_effekt_dobavit_blok_effekta_1_zagolovok: 'ГИАЛУРОНОВАЯ КИСЛОТА',

        blok_effekt_dobavit_blok_effekta_1_opisanie: 'глубоко увлажняет кожу, поддерживает водный баланс',

        postoyannye_dannye_zagolovok_sostava: 'Состав средств',
        postoyannye_dannye_podpis_sostav: 'Посмотрите состав средств, нажав на кнопку',
        postoyannye_dannye_podpis_vesa: 'Вес упаковки',

        podpis_v_hlebnyh_kroshkah: 'Натуральная линия для лица',

        blok_otzyvy_zagolovok: 'Отзывы наших клиентов',

        blok_effekt_dobavit_blok_effekta_2_zagolovok: 'РОДИОЛА РОЗОВАЯ',

        blok_effekt_dobavit_blok_effekta_2_opisanie:
            'стимулирует обменные процессы, повышает защитные функции кожи и сопротивляемость внешним воздействиям, насыщает кожу витаминами.',

        postoyannye_dannye_podpis_obema: 'Объем упаковки'
    },
    {
        id: 7859,
        isSet: 1,
        title: 'CHILI MAGIC — КРЕМ',
        title_short: 'CHILI MAGIC',
        desc_short: null,
        desc: 'Средство для антицеллюлитного обертывания или массажа, предотвращает появления растяжек и целлюлита, в комплексе с другими процедурами является активным средством по борьбе с несовершенствами кожи и поддержанием ее здорового состояния. Хорошо разогревает кожу, улучшает кровообращение, стимулирует выравнивание кожи. Для всех типов кожи, для зонального применения. Разогревающий эффект. Смягчение, стимуляция кожи. Аромат: лайм и ваниль. Не рекомендуется использовать во время беременности и лактации',

        count: 1,

        weight: 200,
        weightType: 'Г',
        cost: 1290,
        categories: 'Для тела, Новинки',
        imageUrl: 'https://1790009369.rsc.cdn77.org/images/tovard-1.png',
        zagolovok_sostava: 'Состав крема',
        sostav: 'Aqua,Triticumvulgare(Wheat)Germoil, ButyrospermumParkii(Shea)oil,Glycerin(Vegetable), Cetearyl Alcohol, Polysorbate 60, Theobroma Cacao (Cocoa) Seed Butter, Vitis Vinifera (Grape) Seed Oil, Coffea Arabica (Coffee) Seed oil, Colloidal Gold, Capsicum Annuum Extract, Glyceryl Stearate, Palmitic Acid, Cellulose Gum, Laminaria Extract, Isopropyl Palmitate, Carbomer, Dehydroacetic Acid, Benzyl Alcohol, Disodium Edta, Sodium Hydroxide, Fragrance.',
        blok_rekomendaciya_zagolovok: 'РЕКОМЕНДУЕТ ИМЕННО ЭТОТ ПРОДУКТ?',

        blok_rekomendaciya_podpis_k_zagolovku: 'ПОЧЕМУ ЛИЗА МИЛЛЕР',

        blok_effekt_zagolovok: 'Эффект',

        blok_ingredienty_zagolovok: 'ДЕЙСТВУЮЩИЕ ИНГРЕДИЕНТЫ',

        blok_ingredienty_ingredient_1: 'ЭКСТРАКТ  ﻿ВИНОГРАДА',

        blok_ingredienty_ingredient_2: 'ЭКСТРАКТ ЭНТЕРОМОРФЫ',

        blok_ingredienty_ingredient_3: 'МАСЛО<br>МЯТЫ',

        blok_ingredienty_ingredient_4: 'ЭКСТРАКТ ﻿ЛАМИНАРИИ',

        blok_ingredienty_ingredient_5: 'КОФЕИН',

        blok_ingredienty_ingredient_6: 'МЕНТОЛ',

        blok_ingredienty_ingredient_7: 'МАСЛО РОЗМАРИНА',

        blok_primenenie_kontent:
            'нанести небольшое количество крем на проблемные участки бедер, ягодиц, живота, растереть крем по массажным линиям и сделать массаж с помощью ролика или рук. Важно! Крем нельзя смывать ранее, чем через 30 минут после нанесения, так как может появиться сильное жжение.',

        blok_do_i_posle_zagolovok: 'А так же до/после',

        blok_effekt_dobavit_effekt_0_effekt: 'УМЕНЬШАЕТ ОБЪЕМЫ В ПРОБЛЕМНЫХ ЗОНАХ',

        blok_effekt_dobavit_blok_effekta_0_img: 'https://1790009369.rsc.cdn77.org/images/c25f9b145d8f6637be57a95f30b0aa0b.png',
        blok_effekt_dobavit_blok_effekta_1_img: 'https://1790009369.rsc.cdn77.org/images/Groaup-89.png',
        blok_effekt_dobavit_blok_effekta_2_img: null,

        blok_effekt_dobavit_effekt_1_effekt: 'НАСЫЩАЕТ КОЖУ ВИТАМИНАМИ И МИКРОЭЛЕМЕНТАМИ',

        blok_effekt_dobavit_effekt_2_effekt: 'ПРОДЛЕВАЕТ МОЛОДОСТЬ КОЖИ',

        blok_effekt_dobavit_blok_effekta_0_zagolovok:
            'Питательные масла Ши, Оливы и Какао быстро улучшают состояние кожного покрова, усиливают упругость и плотность кожи.',

        blok_effekt_dobavit_blok_effekta_1_zagolovok:
            'Экстракт винограда позволяет эффективно увлажнить кожу и способствует выведению шлаков',

        postoyannye_dannye_zagolovok_sostava: 'Состав крема',
        postoyannye_dannye_podpis_sostav: 'Посмотрите состав крема, нажав на кнопку',
        postoyannye_dannye_podpis_vesa: 'Вес упаковки',

        naznachenie_tovara: 'Антицеллюлитный крем обертывание для массажа роликом',
        podpis_v_hlebnyh_kroshkah: 'Chili Magic',

        blok_otzyvy_zagolovok: 'Отзывы наших клиентов',

        postoyannye_dannye_podpis_obema: 'Объем упаковки'
    },
    {
        id: 8322,
        Тип: 'simple',
        title: '17 oils butter -  баттер',
        desc_short: null,
        desc: 'Роскошный баттер на основе 17 драгоценных масел с разных концов света. Глубоко увлажняет и питает кожу. Подходит для любого типа кожи. При регулярном использовании разглаживает растяжки и выравнивает цвет кожи',
        weight: 200,
        weightType: 'мл',
        cost: 1390,
        categories: 'Новинки',
        imageUrl: 'https://1790009369.rsc.cdn77.org/images/17_oil.png',

        zagolovok_sostava: 'Состав крема',

        sostav: 'Состав/INCI: Butyrospermum Parkii (Shea) Oil, Elaeis Guineensis (Palm) Kernel Oil Cocos Nucifera (Coconut) Oil, Vitis Vinifera (Grape) Seed Oil,\n Theobroma Cacao (Cocoa) Seed Butter, Tocopherol, Aloe Barbadensis (Aloe Vera) Butter Oil, Simmondsia Chinensis (Jojoba) Seed Oil, Macadamia Ternifolia Seed Oil, Camellia Oleifera Seed Oil, Pruntus Armeniaca Kernel (Apricot) Oil,  Juglans Regia (Walnut ) Seed Oil, Chia Seed oil,  Prunus Amygdalus Dulcis (Sweet Almond) Oil, Triticum Vulgare (Wheat) Germ Oil, Persea Gratissima (Avocado) Oil, Olea Europaea (Olive) Oil,  Oryza Sativa (Rice) Germ Oil, Fragrance',

        blok_rekomendaciya_zagolovok: 'РЕКОМЕНДУЕТ ИМЕННО ЭТОТ ПРОДУКТ?',

        blok_rekomendaciya_podpis_k_zagolovku: 'ПОЧЕМУ ЛИЗА МИЛЛЕР',

        blok_rekomendaciya_kontent: '',

        blok_rekomendaciya_ikonka_v_ramke: '',

        blok_rekomendaciya_zagolovok_v_ramke: '',

        blok_rekomendaciya_opisanie_v_ramke: '',

        blok_rekomendaciya: '',

        blok_effekt_zagolovok: 'Эффект',

        blok_effekt_ikonka: '',

        blok_effekt_opisanie_sverhu: '',

        blok_effekt_opisanie_snizu: '',

        blok_effekt_dobavit_effekt: 3,

        blok_effekt: '',

        blok_ingredienty_zagolovok: 'ДЕЙСТВУЮЩИЕ ИНГРЕДИЕНТЫ',

        blok_ingredienty_ingredient_1: 'МАСЛО ШИ',

        blok_ingredienty_ingredient_2: 'КОКОСОВОЕ МАСЛО',

        blok_ingredienty_ingredient_3: 'МАСЛО КАКАО',

        blok_ingredienty_ingredient_4: 'ПЕРСИКОВОЕ МАСЛО',

        blok_ingredienty_ingredient_5: 'АЛОЭ МАСЛО',

        blok_ingredienty_ingredient_6: 'МАСЛО МАКАДАМИЯ',

        blok_ingredienty_ingredient_7: 'МАСЛО АВОКАДО',

        blok_ingredienty: '',

        blok_primenenie_zagolovok: 'Применение',

        blok_primenenie_kontent: 'Нанести небольшое количество баттера на кожу, распределить массажными движениями.',

        blok_primenenie_video: '',

        blok_primenenie: '',

        blok_do_i_posle_zagolovok: 'А так же до/после',

        blok_do_i_posle_dobavit_sravnenie: '',

        blok_do_i_posle: '',

        blok_effekt_dobavit_effekt_0_effekt: 'Гладкая и бархатная кожа',

        blok_effekt_dobavit_effekt_1_effekt: 'Глубокий детокс за счет натуральных масел',

        blok_effekt_dobavit_effekt_2_effekt: 'Профилактика растяжек',

        blok_do_i_posle_dobavit_sravnenie_0_do: '',

        blok_do_i_posle_dobavit_sravnenie_0_posle: '',

        blok_do_i_posle_dobavit_sravnenie_1_do: '',

        blok_do_i_posle_dobavit_sravnenie_1_posle: '',

        opisanie_tovara: '',

        blok_effekt_dobavit_blok_effekta_0_ikonka: 7803,

        blok_effekt_dobavit_blok_effekta_0_img: 'https://1790009369.rsc.cdn77.org/images/img_20180504_063631.jpeg',
        blok_effekt_dobavit_blok_effekta_1_img: 'https://1790009369.rsc.cdn77.org/images/avocado-emoji.png',
        blok_effekt_dobavit_blok_effekta_2_img:
            'https://1790009369.rsc.cdn77.org/images/png-transparent-cocoa-bean-food-plant-bean-ingredient-watercolor-paint-wet-ink.png',

        blok_effekt_dobavit_blok_effekta_0_zagolovok: 'МАСЛО АЛОЭ',

        blok_effekt_dobavit_blok_effekta_0_opisanie: '',

        blok_effekt_dobavit_blok_effekta_1_ikonka: 431,

        blok_effekt_dobavit_blok_effekta_1_zagolovok: 'МАСЛО АВОКАДО',

        blok_effekt_dobavit_blok_effekta_1_opisanie: '',

        blok_effekt_dobavit_blok_effekta: 3,

        postoyannye_dannye_zagolovok_sostava: 'Состав баттера',

        postoyannye_dannye_podpis_sostav: 'Посмотрите состав баттера, нажав на кнопку',

        postoyannye_dannye_podpis_vesa: 'Вес упаковки',

        postoyannye_dannye_zagolovok_kompleks: '',

        postoyannye_dannye_podpis_kompleks: '',

        postoyannye_dannye: '',

        naznachenie_tovara: '',

        vybor_varianta: 1,

        podpis_v_hlebnyh_kroshkah: '',

        blok_ingredienty_izobrazhenie: 8328,

        skryt_blok_rekomendacii: 1,

        skryt_blok_sravneniya: 1,

        skryt_blok_otzyvov: 1,

        blok_primenenie_video_video: '',

        blok_primenenie_video_poster: '',

        blok_primenenie_poster: 8330,

        blok_do_i_posle_dobavit_sravnenie_2_do: '',

        blok_do_i_posle_dobavit_sravnenie_2_posle: '',

        blok_otzyvy_zagolovok: 'Отзывы наших клиентов',

        blok_otzyvy_dobavit_slajd: '',

        blok_otzyvy: '',

        blok_effekt_dobavit_blok_effekta_2_ikonka: 415,

        blok_effekt_dobavit_blok_effekta_2_zagolovok: 'МАСЛО КАКАКО',

        blok_effekt_dobavit_blok_effekta_2_opisanie: '',

        obem: '',

        postoyannye_dannye_podpis_obema: 'Объем упаковки',

        postoyannye_dannye_obem: 200,

        blok_otzyvy_dobavit_slajd_0_foto: '',

        blok_otzyvy_dobavit_slajd_0_imya: '',

        blok_otzyvy_dobavit_slajd_0_podpis: '',

        blok_otzyvy_dobavit_slajd_0_video: '',

        blok_otzyvy_dobavit_slajd_0_otzyv: '',

        blok_otzyvy_dobavit_slajd_1_foto: '',

        blok_otzyvy_dobavit_slajd_1_imya: '',

        blok_otzyvy_dobavit_slajd_1_podpis: '',

        blok_otzyvy_dobavit_slajd_1_video: '',

        blok_otzyvy_dobavit_slajd_1_otzyv: '',

        blok_otzyvy_dobavit_slajd_2_foto: '',

        blok_otzyvy_dobavit_slajd_2_imya: '',

        blok_otzyvy_dobavit_slajd_2_podpis: '',

        blok_otzyvy_dobavit_slajd_2_video: '',

        blok_otzyvy_dobavit_slajd_2_otzyv: ''
    }
];

/* 
{
        id: 585,

        title: 'Крем для ног',
        Опубликован: 0,
        desc_short: null,
        desc: '<div class="page" title="Page 1">\n\\n<div class="section">\n\\n<div class="layoutArea">\n\\n<div class="column">\n\\n<div class="page" title="Page 1">\n\\n<div class="section">\n\\n<div class="layoutArea">\n\\n<div class="column">\n\\n\n\\n88% компонентов натурального происхождения\n\\n\n\\nМягкое очищающее средство подходит для ежедневного очищения кожи тела. При контакте с водой молочно-масляная формула превращается в мыльную пену, тщательно удаляя все загрязнения и раскрываясь ароматом спелого арбуза, оставляет кожу невероятно гладкой и шелковистой. Гель для душа содержит масло авокадо, естественно богатое лецитином и антиоксидантами, которые помогают успокоить и восстановить тонус кожи. Растительный глицерин и масло зародышей пшеницы оказывают интенсивное питательное, увлажняющее и смягчающее действие. В результате кожа становится идеально чистой и гладкой.\n\\n\n\\n</div>\n\\n</div>\n\\n</div>\n\\n</div>\n\\n</div>\n\\n</div>\n\\n</div>\n\\n</div>',

        count: 1,

        weight: 200,
        weightType: 'Г',
        cost: 690,
        categories: 'Для тела, Новинки',
        imageUrl: 'https://1790009369.rsc.cdn77.org/images/Gel-dlya-dusha-viz-1.png',

        Апсейл: 'id:259',
        Кросселы: 'id:278',

        zagolovok_sostava: 'Состав геля для душа',
        sostav: 'Состав/INCI: Aqua, Sodium Laureth Sulfate, Cocamidopropyl Betaine, Decyl Glucoside, Cocamide DEA, Sodium Chloride, Panthenol, Polyquaternium-7, Glycerin, Fragrance, Triticum Vulgare (Wheat) Germ Oil, Persea Gratissima (Avocado) Oil, Coco Glucoside, Citric Acid, PEG-7 Glyceryl Cocoate, Tetrasodium EDTA, Styrene/Acrylates Copolymer, Chloromethylisothiazolinone, Methylisothiazolinone',
        blok_rekomendaciya_zagolovok: 'РЕКОМЕНДУЕТ ИМЕННО ЭТОТ ПРОДУКТ?',

        blok_rekomendaciya_podpis_k_zagolovku: 'ПОЧЕМУ ЛИЗА МИЛЛЕР',

        blok_effekt_zagolovok: 'Эффект',

        blok_effekt_ikonka: null,

        blok_effekt_opisanie_sverhu: null,

        blok_effekt_opisanie_snizu: null,

        blok_effekt_dobavit_effekt: 2,

        blok_ingredienty_zagolovok: 'ДЕЙСТВУЮЩИЕ ИНГРЕДИЕНТЫ',

        blok_ingredienty_ingredient_1: 'МАСЛО АВОКАДО',

        blok_ingredienty_ingredient_2: 'РАСТИТЕЛЬНЫЙ ГЛИЦЕРИН',

        blok_ingredienty_ingredient_3: null,

        blok_ingredienty_ingredient_4: 'АНТИОКСИДАНТЫ',

        blok_ingredienty_ingredient_5: null,

        blok_ingredienty_ingredient_6: 'МАСЛО ЗАРОДЫШЕЙ ПШЕНИЦЫ',

        blok_ingredienty_ingredient_7: null,

        blok_primenenie_kontent:
            '<div class="page" title="Page 1">\n<div class="section">\n<div class="layoutArea">\n<div class="column">\n<div class="page" title="Page 1">\n<div class="section">\n<div class="layoutArea">\n<div class="column">\n\nНанести на влажную кожу тела, массировать до появления пены, затем смыть. Меры предосторожности: только для наружного применения.\n\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>',

        blok_effekt_dobavit_effekt_0_effekt: 'Оставляет кожу невероятно гладкой и шелковистой',

        blok_effekt_dobavit_effekt_1_effekt: 'Интенсивное питательное, увлажняющее и смягчающее действие',

        blok_effekt_dobavit_blok_effekta_0_zagolovok:
            'содержит масло авокадо, естественно богатое лецитином и антиоксидантами, которые помогают успокоить и восстановить тонус кожи',

        blok_effekt_dobavit_blok_effekta_1_zagolovok:
            'При контакте с водой молочно-масляная формула превращается в мыльную пену, тщательно удаляя все загрязнения и раскрываясь ароматом спелого арбуза',

        postoyannye_dannye_zagolovok_sostava: 'Состав баттера',
        postoyannye_dannye_podpis_sostav: 'Посмотрите состав баттера, нажав на кнопку',
        postoyannye_dannye_podpis_vesa: 'Вес упаковки',

        naznachenie_tovara: 'Нежное молочко для душа',
        podpis_v_hlebnyh_kroshkah: 'Mango air - роскошный баттер',

        blok_otzyvy_zagolovok: 'Отзывы наших клиентов',

        postoyannye_dannye_podpis_obema: 'Объем упаковки'
    },
    {
        id: 589,

        title: 'Бокс подарочный - Бестселлеры Millidge',
        Опубликован: 0,
        desc_short: null,
        desc: 'В набор входят:\n\\n<ul>\n\\n \t<li>Масло массажное Ginger Power</li>\n\\n \t<li>Банка для вакуумного массажа</li>\n\\n \t<li>Крем-обертывание Chili Magic</li>\n\\n \t<li>Ролик массажный</li>\n\\n \t<li>Баттер Mango air - 11 масел</li>\n\\n</ul>\n\\n&nbsp;',

        count: 1,

        weight: null,
        weightType: 'Г',
        cost: 3950,
        categories: 'Новинки',
        imageUrl: null,
        zagolovok_sostava: 'Состав каждого средства можно узнать на странице товара',
        sostav: null,
        blok_rekomendaciya_zagolovok: 'РЕКОМЕНДУЕТ ИМЕННО ЭТОТ ПРОДУКТ?',

        blok_rekomendaciya_podpis_k_zagolovku: 'ПОЧЕМУ ЛИЗА МИЛЛЕР',

        blok_effekt_zagolovok: null,

        blok_effekt_ikonka: null,

        blok_effekt_opisanie_sverhu: null,

        blok_effekt_opisanie_snizu: null,

        blok_effekt_dobavit_effekt: null,

        blok_ingredienty_zagolovok: null,

        blok_ingredienty_ingredient_1: 'Масло массажное Ginger Power',

        blok_ingredienty_ingredient_2: 'Банка для вакуумного массажа',

        blok_ingredienty_ingredient_3: 'Крем-обертывание Chili Magic',

        blok_ingredienty_ingredient_4: 'Ролик массажный',

        blok_ingredienty_ingredient_5: 'Баттер Mango air - 11 масел',

        blok_ingredienty_ingredient_6: 'Подарочная коробка',

        blok_ingredienty_ingredient_7: null,

        blok_primenenie_zagolovok: null,

        blok_primenenie_kontent: null,

        blok_do_i_posle_zagolovok: 'А так же до/после',

        blok_effekt_dobavit_effekt_0_effekt: null,

        blok_effekt_dobavit_effekt_1_effekt: null,

        blok_effekt_dobavit_blok_effekta_0_zagolovok: null,

        blok_effekt_dobavit_blok_effekta_1_zagolovok: null,

        postoyannye_dannye_zagolovok_sostava: null,
        postoyannye_dannye_podpis_sostav: null,
        postoyannye_dannye_podpis_vesa: '1000 грамм',

        blok_otzyvy_zagolovok: 'Отзывы наших клиентов',

        blok_otzyvy_dobavit_slajd: 3,

        blok_otzyvy_dobavit_slajd_0_foto: null,

        blok_otzyvy_dobavit_slajd_0_imya: 'Анастасия',

        blok_otzyvy_dobavit_slajd_0_podpis: null,

        blok_otzyvy_dobavit_slajd_0_video: null,

        blok_otzyvy_dobavit_slajd_0_otzyv:
            'Перепробовала много разных брендов масел , в том числе и дорогущих , но это масло что-то с чем-то ,такое лёгкое, мягкое -супер. Расход супер экономичный, баночки по телу скользят великолепно, я рада что не ошиблась в выборе масла для тела. Советую!',

        blok_otzyvy_dobavit_slajd_1_foto: null,

        blok_otzyvy_dobavit_slajd_1_imya: 'Марина',

        blok_otzyvy_dobavit_slajd_1_podpis: null,

        blok_otzyvy_dobavit_slajd_1_video: null,

        blok_otzyvy_dobavit_slajd_1_otzyv:
            'Я тоже не устояла и сделала заказ. Все пришло в целости и невредимости. Я уже даже опробовала. Крем-обвертывание имеет приятный запах, нежная текстура, начал действовать сразу после нанесения. Ну ролик просто супер. Хорошо прорабатывает проблемные зоны. Покупкой довольна, обязательно попробую скраб.',

        blok_otzyvy_dobavit_slajd_2_foto: null,

        blok_otzyvy_dobavit_slajd_2_imya: 'Светлана',

        blok_otzyvy_dobavit_slajd_2_podpis: null,

        blok_otzyvy_dobavit_slajd_2_video: null,

        blok_otzyvy_dobavit_slajd_2_otzyv:
            'Крем пушка, первый раз наносила на сухую кожу, проработала роликом (который тоже пушка) и решила не смывать легла спать, кожа не горела было тепло и приятно, на утро все хорошо кожа на месте ))). В следующий раз решила нанести в ванной на влажную кожу, проработала роликом и горела я огнём и синим пламенем, смывала его холодной водой и потом ещё горела минут 20 после. Эффект: кожа бархат, убирает или нет неровности пока сложно сказать, буду гореть дальше, НО мне во второй раз Понравилось больше чем в первый. 👌'
    },
*/
